<p-tabs
  appTabsUnsavedReveal
  [value]="activeTabIndex()"
  (valueChange)="onTabChange($event!)"
  [lazy]="false"
>
  <p-tablist>
    <p-tab [value]="0" [appTabStatus]="tabStatus()">
      {{ 'provider.tenderWizard.rfq.projectParameters' | transloco }}
    </p-tab>
    <p-tab [value]="1" [appTabStatus]="tabStatus()">
      {{ 'provider.tenderWizard.rfq.guidance' | transloco }}
    </p-tab>
  </p-tablist>

  <p-tabpanels class="mt-6">
    <div>
      <p-tabpanel [value]="0">
        <app-tender-project-rfq-price-list [isReadOnly]="true" [tenderId]="tenderId()" />
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <app-rfq-document-upload-content [isEditable]="false" [tenderId]="tenderId()" />
      </p-tabpanel>
    </div>
  </p-tabpanels>
</p-tabs>
